export default __webpack_public_path__ + "static/media/2way.8462d27d.png";